<template>

<BaseFrame>
<div slot="content">
    <lk-form :model='headOfficeForm' label-position="right" :label-width="100">
      <lk-card title="基本信息">

        <lk-row >
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='10'>
            <lk-form-item label='门店名称' >
              <lk-input :maxlength='100' placeholder='请输入' v-model="branchForm.name"></lk-input>
            </lk-form-item>
          </lk-col>
        </lk-row>

      </lk-card>
    </lk-form>
</div>
</BaseFrame>
</template>
<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';

export default {
  name: 'Print',
  components: {
    BaseFrame,
  },
  data() {
    return {
      branchForm: {
        name: '',
      },
    };
  },
  created() {

  },
};
</script>
<style lang="less" scoped>

</style>
